import { api1 } from "../utils/axiosInstance";
export const mentorPricingRate = async (payload) => {
  try {
    // Send request with FormData
    const response = await api1.put("/api/mentor-meeting-rate", payload);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error while fetching data:",
      error.response || error.message
    );
    return null;
  }
};
